<div class="npdc-title">
  <h1 class="title">Geological sample archive</h1>
</div>

<p>
  This <a routerLink="/dataset/{{ geologicalSampleDatasetId }}">dataset</a> is the digital
  representation of the geological samples gathered by the Norwegian Polar Institute during
  expeditions in the Norwegian Arctic and in Antarctica, with information on locality and rock type,
  a short geological description and photos. The physical samples are stored at the Fram Centre in
  Tromsø.
</p>

<p>
  Results can be filtered by geologist, expedition or area using the button next to the search
  input.
</p>

<div class="npdc-search">
  <div class="npdc-search__input">
    <div class="npdc-search__input__prefix">
      @if (sampleList.isLoading()) {
        <mat-spinner matPrefix [diameter]="24"></mat-spinner>
      } @else {
        <mat-icon>search</mat-icon>
      }
    </div>
    <input
      type="search"
      placeholder="Search archive"
      [value]="search()"
      (keydown.enter)="onSearch($any($event).target?.value || '', location(), 0)"
    />
  </div>
  <button mat-icon-button (click)="advancedSearch()">
    <mat-icon>tune</mat-icon>
  </button>
</div>

@if (location() || parsedFilters().length) {
  <p>
    <mat-chip-set>
      @if (location()) {
        <mat-chip highlighted title="{{ location() }}">
          Location filter
          <mat-icon matChipRemove (click)="onSearch($any($event).target?.value || search(), '', 0)"
            >cancel</mat-icon
          >
        </mat-chip>
      }
      @for (f of parsedFilters(); track f) {
        @if (f !== 'draft:false') {
          <mat-chip highlighted title="{{ f }}">
            {{ f.split(':')[1] }}
            <mat-icon matChipRemove (click)="onFilterClear(f)">cancel</mat-icon>
          </mat-chip>
        }
      }
    </mat-chip-set>
  </p>
}

@if (mapExpanded()) {
  <p>
    <mat-card class="npdc-leaflet" appearance="outlined">
      <app-leaflet-group [geometry]="geojson()" [readonly]="true" [height]="'250px'" />
    </mat-card>
  </p>
}

<app-list [resource]="sampleList">
  @if (!sampleList.error()) {
    <mat-nav-list>
      @for (sample of sampleList.value()?.items; track sample.id; let isLast = $last) {
        <a mat-list-item routerLink="/geology/sample/{{ sample.id }}">
          <mat-icon matListItemIcon>landslide</mat-icon>
          <span matListItemTitle
            >{{ sample.content.sampleName }}
            @if (sample.content.lithology) {
              - {{ sample.content.lithology }}
            }
            @if (sample.content.draft) {
              「Draft」
            }
          </span>
          <span matListItemLine>
            @if (sample.content.placename) {
              <b>Place: </b>{{ sample.content.placename }}
            } @else {
              <b>Place: </b>N/A
            }
            @if (sample.content.collectedYear) {
              , {{ sample.content.collectedYear }}
            }
          </span>
          <span matListItemLine>
            @if (sample.content.expedition) {
              <b>Expedition: </b>{{ sample.content.expedition }}
            } @else {
              <b>Expedition: </b>N/A
            }
          </span>
        </a>
      }
    </mat-nav-list>

    <mat-paginator
      showFirstLastButtons
      (page)="onPage($event)"
      [length]="count()"
      [pageIndex]="page()"
      [pageSize]="pageSize()"
      [pageSizeOptions]="pageSizeOptions"
    />
  }
</app-list>
